import React from "react";
import {Box, CircularProgress} from "@mui/material";

type Props = {
    loading?: boolean;
    children?: React.ReactNode;
};

/**
 * Loading overlay for charts that don't have a built-in loading state (e.g. plain D3/SVG charts),
 * mirroring the mask + spinner MithraEchart shows via echarts' own `showLoading()`.
 */
export const ChartLoadingOverlay: React.FC<Props> = ({loading, children}) => (
    <Box position="relative">
        {children}
        {loading &&
            <Box
                position="absolute"
                top={20}
                left={20}
                right={20}
                bottom={20}
                display="flex"
                alignItems="center"
                justifyContent="center"
                bgcolor="rgba(255, 255, 255, .55)"
            >
                <CircularProgress size={32} sx={{color: '#2D6FF5'}}/>
            </Box>
        }
    </Box>
);
